import { render, staticRenderFns } from "./OntologyDiagramMappingTable.vue?vue&type=template&id=9d8df472&"
import script from "./OntologyDiagramMappingTable.vue?vue&type=script&lang=ts&"
export * from "./OntologyDiagramMappingTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports